module.exports = "/_next/static/images/ourPartnersLogo14-d7ca8af136457b29c3d07d8d94f6780f.webp";